// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vue2TouchEvents from 'vue2-touch-events'
import router from './router'
import './assets/styles/index.css'

Vue.config.productionTip = false
Vue.use(Vue2TouchEvents)

// 创建 SDK 配置对象（SDK 未加载时不影响页面启动）
let config = {
    appId: '743689de9f5d45bea99fea4d031858b3',
    serverUrl: 'https://receiver.habby.fun/sync_js'
}
let thinkingdata = window.thinkingdata
if (thinkingdata && typeof thinkingdata.init === 'function') {
    try {
        thinkingdata.init(config)
    } catch (e) {
        console.warn('thinkingdata init failed', e)
    }
} else {
    // 兜底，避免后续 track 报错导致白屏
    window.thinkingdata = {
        init: function () {},
        track: function () {}
    }
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js